import { useDispatch, useSelector } from '@redux';
// import { getAllOrderHistories } from '@redux/orderHistories/actions';
import { cancelOrder } from '@redux/orders/actions';
import { Modal, Form, Input } from 'antd';
import FormItem from 'components/form/FormItem';
import { RestInputContext } from 'components/form/RestInputContext';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from 'utils/formattedString';
import SelectCustom from '../VNCitySelector/SelectCustom';
import { ORDER_TTB_CANCEL_REASONS } from 'constants/ordersTabTryBuy';

interface ICancelModalProps {
  orderNumber?: string;
  id?: string;
  createdAt?: string;
  visible?: boolean;
  onCancel?: () => void;
}

const CancelModal = ({
  orderNumber,
  id,
  createdAt,
  visible,
  onCancel,
}: ICancelModalProps) => {
  const { t } = useTranslation();
  const loading = useSelector((state) => state.orders.loading);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    dispatch(
      cancelOrder({
        data: {
          id,
          data: values,
        },
      }),
    ).then((res) => {
      if (!res?.payload?.error) {
        onCancel();
        window.location.reload();
      }
    });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={() => {
        form.submit();
      }}
      okButtonProps={{
        loading,
      }}
      title={t('orderDetail.action.cancel')}
    >
      <RestInputContext.Provider value={{ form }}>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <div className="d-flex space-between align-center">
            <div>{t('orders.orderNumber')}</div>
            <b>{orderNumber}</b>
          </div>
          <div className="d-flex space-between align-center">
            <div>{t('orders.createdAt')}</div>
            <b>{formatDateTime(createdAt)}</b>
          </div>
          <br />
          <SelectCustom
            source="cancelReason"
            resourceData={ORDER_TTB_CANCEL_REASONS}
            valueProp="value"
            titleProp="text"
            required
            header={t('orders.cancelReason')}
          />
          <FormItem name="cancelNote" label={t('orders.cancelNote')}>
            <Input.TextArea />
          </FormItem>
        </Form>
      </RestInputContext.Provider>
    </Modal>
  );
};

export default CancelModal;
